import img1 from "./bali-1.jpg";
import img2 from "./bali-2.jpg";
import img3 from "./bali-3.jpg";
import img4 from "./bali-4.jpg";
import img5 from "./bali-5.jpg";
import img6 from "./bali-6.jpg";
import img7 from "./bali-7.jpg";
import img8 from "./bali-8.jpg";
import img9 from "./bali-9.jpg";
import img10 from "./bali-10.jpg";
import img11 from "./bali-11.jpg";
import img12 from "./bali-12.jpg";
import img13 from "./bali-13.jpg";
import img14 from "./bali-14.jpg";
import img15 from "./bali-15.jpg";
import img16 from "./bali-16.jpg";
import img17 from "./bali-17.jpg";
import img18 from "./bali-18.jpg";
import img19 from "./bali-19.jpg";
import img20 from "./bali-20.jpg";
import img21 from "./bali-21.jpg";
import img22 from "./bali-22.jpg";
import img23 from "./bali-23.jpg";
import img24 from "./bali-24.jpg";
import img25 from "./bali-25.jpg";
import img26 from "./bali-26.jpg";
import img27 from "./bali-27.jpg";
import img28 from "./bali-28.jpg";
import img29 from "./bali-29.jpg";
import img30 from "./bali-30.jpg";
import img31 from "./bali-31.jpg";
import img32 from "./bali-32.jpg";
import img33 from "./bali-33.jpg";
import img34 from "./bali-34.jpg";
import img35 from "./bali-35.jpg";
import img36 from "./bali-36.jpg";
import img37 from "./bali-37.jpg";
import img38 from "./bali-38.jpg";
import img39 from "./bali-39.jpg";
import img40 from "./bali-40.jpg";
import img41 from "./bali-41.jpg";
import img42 from "./bali-42.jpg";
import img43 from "./bali-43.jpg";
import img44 from "./bali-44.jpg";
import img45 from "./bali-45.jpg";
import img46 from "./bali-46.jpg";
import img47 from "./bali-47.jpg";
import img48 from "./bali-48.jpg";
import img49 from "./bali-49.jpg";

export const baliImages = [
  img1, img2, img3, img4, img5, img6, img7, img8, img9, img10,
  img11, img12, img13, img14, img15, img16, img17, img18, img19, img20,
  img21, img22, img23, img24, img25, img26, img27, img28, img29, img30,
  img31, img32, img33, img34, img35, img36, img37, img38, img39, img40,
  img41, img42, img43, img44, img45, img46, img47, img48, img49,
];
